// Display helpers for the Analysis page. Weeks come from the API as year * 100 + week.

export const formatWeek = (yearWeek) => {
  if (yearWeek === null || yearWeek === undefined) return '--';
  const year = Math.floor(yearWeek / 100);
  const week = yearWeek % 100;
  return `S${String(week).padStart(2, '0')} ${year}`;
};

export const formatWeekList = (weeks, max = 6) => {
  if (!weeks || weeks.length === 0) return '';
  const shown = weeks.slice(0, max).map(formatWeek).join(', ');
  return weeks.length > max ? `${shown} … (+${weeks.length - max})` : shown;
};

// A series more than this many weeks behind is shown as stopped, not late
export const STOPPED_AFTER_WEEKS = 8;

export const lagStatus = (lagWeeks) => {
  if (lagWeeks <= 0) return { label: 'À jour', tone: 'ok' };
  if (lagWeeks > STOPPED_AFTER_WEEKS) return { label: `Arrêtée (${lagWeeks} sem.)`, tone: 'muted' };
  if (lagWeeks === 1) return { label: '1 sem. de retard', tone: 'warn' };
  return { label: `${lagWeeks} sem. de retard`, tone: 'bad' };
};

export const formatDate = (value) => {
  if (!value) return '--';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);
  return date.toLocaleString('fr-FR', {
    year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit',
  });
};

export const formatUnits = (value) =>
  value === null || value === undefined ? '--' : Number(value).toLocaleString('fr-FR', { maximumFractionDigits: 0 });

export const METRIC_LABELS = {
  sales_quantity: 'Ventes',
  stock_quantity: 'Stock',
  stock_available: 'Stock dispo',
};
